var _g, _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _circle3, _circle4, _path1, _path10, _path11, _circle5, _circle6, _path12, _circle7, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBat10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 126,
    viewBox: "0 0 192 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_50342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9784 4.09931C48.9374 1.47557 52.4783 0.599273 54.9784 0.0993072C57.4785 -0.400659 64.4783 1.09925 66.4784 2.09931C68.4785 3.09936 69.9775 10.0994 74.9775 11.5994C79.9775 13.0994 170.477 10.5994 173.478 10.5994C176.478 10.5994 180.978 14.7799 180.978 18.0994V28.5994C180.978 32.5994 180.978 35.5993 177.978 37.0994C173.478 39.3494 173.63 40.1721 171.978 42.0994C170.326 44.0267 170.376 44.6335 170.978 47.0993C171.879 50.7822 174.441 52.2816 176.978 55.0994C181.478 60.0994 182.643 61.1722 184.478 66.0994C186.742 72.1823 187.455 76.1086 187.478 82.5994C187.501 89.284 186.411 92.5923 183.478 98.5994C180.142 105.434 175.648 109.444 168.978 113.099C164.429 115.593 161.166 115.599 155.978 115.599C147.978 115.599 144.512 115.18 136.978 113.099C131.858 111.685 129.136 110.371 123.978 109.099C111.978 106.139 79.6128 107.493 72.9775 108.599C69.9775 109.099 61.9775 112.109 57.4775 114.099C52.1203 116.469 46.9775 117.599 40.9775 117.599C35.0485 117.599 29.9775 116.099 27.4775 115.099C24.9775 114.099 18.4775 110.099 16.9775 108.599C15.4775 107.099 10.0459 100.63 7.97841 94.5993C5.79217 88.2221 4.56357 84.328 4.97841 77.5993C5.43436 70.2037 6.68396 65.6376 10.9784 59.5993C14.4277 54.7493 17.3027 52.5374 22.4784 49.5993C29.4798 45.6249 38.4775 46.5994 42.4784 44.5993C46.5707 42.5536 48.0202 39.7342 49.9784 35.5993C52.2596 30.7826 53.7358 24.833 51.9784 22.0993L47.4784 15.0993C44.2044 10.7823 43.0194 6.72304 45.9784 4.09931Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.888 27.1144C130.484 29.537 125.616 30.9656 120.592 28.7295C111.365 27.008 104.441 24.8936 104.239 23.8842C104.037 22.8747 106.864 22.6729 106.864 22.6729H111.911L121.198 22.8747L127.052 22.6729C129.961 23.4717 131.292 24.6917 130.888 27.1144Z",
    fill: "black",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.261 82.8356L45.2893 79.8073L53.7686 56.9941L48.9233 55.7828L50.3365 50.5337C50.3365 50.5337 51.5478 46.2943 51.144 45.4866C50.7403 44.6789 47.2085 50.6849 45.2893 58.0035L47.5101 59.6186L40.444 81.2204L42.261 82.8356Z",
    fill: "#ECEBEB",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6041 43.0635L58.3291 40.6358L55.989 39.9834L55.3833 41.0446L53.1626 42.8616L50.538 52.5521L52.5569 53.5616L54.5758 46.6974L55.989 46.0918L57.6041 43.0635Z",
    fill: "#797979",
    stroke: "#797979"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.23019,
    cy: 3.23019,
    r: 4.23019,
    transform: "matrix(-1 0 0 1 45.4912 77.5864)",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.283,
    cy: 30.283,
    r: 28.783,
    transform: "matrix(-1 0 0 1 72.5439 50.5337)",
    stroke: "black",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5386 57.1959L34.1858 105.043M69.1122 88.8921L15.8141 72.5393M26.5141 59.6185L59.8254 103.832M66.2858 68.5015L17.4292 93.5355M37.416 55.3789L47.7122 106.86M60.2292 60.0223L24.0914 102.015M15.4103 83.2393L70.5254 77.9902",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.324 53.5614L121.198 56.3878L122.207 52.552C122.565 51.6625 122.564 51.2105 122.005 50.5331L119.179 49.3218C117.219 49.0574 116.216 49.1813 114.535 49.7255L113.324 53.5614Z",
    fill: "black",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6124 25.3035L62.5697 25.9559C62.5697 25.9559 65.0252 22.4225 64.6699 19.8463C64.5471 18.9558 64.3764 18.4685 64.0643 17.6255C62.7843 14.1687 54.9056 12.8348 57.8058 10.5595C58.1675 10.2757 58.5308 10.3151 58.8152 9.95384C59.6151 8.93782 57.604 7.32942 56.7964 6.72376C55.9888 6.1181 53.9772 4.43606 53.5662 5.71422C53.3142 6.49783 54.4557 6.96044 54.1718 7.73309C54.0359 8.10312 53.7697 8.20301 53.5662 8.54064C52.8235 9.77287 52.2342 10.9327 52.9605 12.1746C53.4795 13.0619 54.3262 13.0172 55.1813 13.5878C56.6374 14.5595 57.5654 14.9865 58.8152 16.2123C60.2678 17.6371 61.5203 18.4431 61.8435 20.452C62.1723 22.4952 60.6124 25.3035 60.6124 25.3035Z",
    fill: "#797979",
    stroke: "#797979"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.517 46.8995L114.738 47.5052L120.391 28.7297L117.968 28.3259L112.517 46.8995Z",
    fill: "#ECEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.911 46.8995L115.141 47.707L112.921 53.7636L121.198 56.5901L120.794 58.2052L153.702 77.7882L155.721 80.8165L152.692 80.6146L119.987 60.8297L112.113 86.2674L114.738 86.8731L115.545 84.6523L151.279 81.2202V84.0466L118.775 87.4787L117.766 87.8825L117.16 95.3523L102.826 91.9202L101.817 88.8919L82.2339 71.5297L71.1302 55.3787L61.2377 38.2184L60.0264 37.6127L59.017 40.641L55.5849 39.2278L59.6226 25.4995L63.2566 26.7108V28.7297C72.6529 49.3692 77.7269 58.0072 86.2717 66.0787C93.4851 69.1193 97.6196 70.0375 105.249 69.5108L111.911 46.8995Z",
    fill: "#ECEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M112.517 46.8995L114.738 47.5052L120.391 28.7297L117.968 28.3259L112.517 46.8995Z",
    stroke: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M111.911 46.8995L115.141 47.707L112.921 53.7636L121.198 56.5901L120.794 58.2052L153.702 77.7882L155.721 80.8165L152.692 80.6146L119.987 60.8297L112.113 86.2674L114.738 86.8731L115.545 84.6523L151.279 81.2202V84.0466L118.775 87.4787L117.766 87.8825L117.16 95.3523L102.826 91.9202L101.817 88.8919L82.2339 71.5297L71.1302 55.3787L61.2377 38.2184L60.0264 37.6127L59.017 40.641L55.5849 39.2278L59.6226 25.4995L63.2566 26.7108V28.7297C72.6529 49.3692 77.7269 58.0072 86.2717 66.0787C93.4851 69.1193 97.6196 70.0375 105.249 69.5108L111.911 46.8995Z",
    stroke: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.283,
    cy: 30.283,
    r: 28.783,
    transform: "matrix(-1 0 0 1 181.966 50.5337)",
    stroke: "black",
    strokeWidth: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.23019,
    cy: 3.23019,
    r: 4.23019,
    transform: "matrix(-1 0 0 1 154.913 77.5864)",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M159.96 57.1959L143.608 105.043M178.534 88.8921L125.236 72.5393M135.936 59.6185L169.247 103.832M175.708 68.5015L126.851 93.5355M146.838 55.3789L157.134 106.86M169.651 60.0223L133.513 102.015M124.832 83.2393L179.947 77.9902",
    stroke: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.615 79.2011L152.087 78.3936L152.289 83.2388L101.212 93.9388",
    stroke: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M105.855 81.2201L104.038 84.6522L104.845 86.0654L108.883 86.873L108.479 88.69L104.643 87.8824L103.634 89.2956L103.836 92.9296H102.019V89.6994L99.596 88.8918L96.7696 90.305L96.1639 88.69L98.9904 87.2767L99.1923 85.6617L96.5677 83.0371L97.5772 81.6239L100.605 84.2484L102.221 83.8447L104.038 80.4126L105.855 81.2201Z",
    fill: "black",
    stroke: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.27736,
    cy: 8.27736,
    r: 6.77736,
    transform: "matrix(-1 0 0 1 110.498 78.3936)",
    stroke: "black",
    strokeWidth: 3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.23019,
    cy: 3.23019,
    r: 3.23019,
    transform: "matrix(-1 0 0 1 105.249 83.6426)",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1642 101.61L102.221 89.0935L103.028 86.6708L101.211 85.8633L99.3944 88.6897L93.5396 101.61H90.9151V103.629L91.9246 105.043H97.7793L98.9906 104.033V101.61H96.1642Z",
    fill: "black",
    stroke: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.81698,
    cy: 1.81698,
    r: 1.81698,
    transform: "matrix(-1 0 0 1 56.3936 4.09961)",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M139.625 15.793C138.133 15.793 136.702 16.4119 135.648 17.5137C134.593 18.6155 134 20.1098 134 21.668V33.418C134 34.9761 134.593 36.4704 135.648 37.5722C136.702 38.674 138.133 39.293 139.625 39.293H167.75C169.242 39.293 170.673 38.674 171.727 37.5722C172.782 36.4704 173.375 34.9761 173.375 33.418V21.668C173.375 20.1098 172.782 18.6155 171.727 17.5137C170.673 16.4119 169.242 15.793 167.75 15.793H139.625ZM167.75 18.7305C168.496 18.7305 169.211 19.04 169.739 19.5908C170.266 20.1417 170.562 20.8889 170.562 21.668V33.418C170.562 34.197 170.266 34.9442 169.739 35.4951C169.211 36.046 168.496 36.3555 167.75 36.3555H139.625C138.879 36.3555 138.164 36.046 137.636 35.4951C137.109 34.9442 136.812 34.197 136.812 33.418V21.668C136.812 20.8889 137.109 20.1417 137.636 19.5908C138.164 19.04 138.879 18.7305 139.625 18.7305H167.75ZM179 27.543C179 28.7116 178.556 29.8323 177.764 30.6587C176.973 31.485 175.9 31.9492 174.781 31.9492V23.1367C175.9 23.1367 176.973 23.6009 177.764 24.4273C178.556 25.2536 179 26.3744 179 27.543Z",
    fill: "#DE0000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_50342",
    x: 0.898438,
    y: 0,
    width: 190.579,
    height: 125.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_50342"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_50342",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBat10);
export default __webpack_public_path__ + "static/media/bat_10.f4bd03cbccf2255a0f7ec003a0fe75a3.svg";
export { ForwardRef as ReactComponent };